

import { FreightCollectInfo, ReturnOrderLineModel, ShippingContact, StandardReturnSubmitResult, submitStandardReturnOrderApi, SubmitStandardReturnOrderApiParameter, submitStandardReturnOrderResult } from "@dana/Services/DanaStandardReturnOrderService";
import { DanaStandardReturnOrderActions } from "@dana/Store/Data/StandardReturns/Reducers/GetStandardReturnOrderReducer";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";

export type SubmitStandardReturnOrderParameter = {
    reason?: string;
    disposition?: string;
    internalRefNumber?: string;
    emailContacts: string[];
    freightCollectInfo?: FreightCollectInfo;
    shippingContact: ShippingContact;
    selectedItems: ReturnOrderLineModel[];
    originalOrderNumber: string;

} & HasOnSuccess<any> &
    HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<SubmitStandardReturnOrderParameter, SubmitStandardReturnOrderApiParameter,ServiceResult<StandardReturnSubmitResult>, DispatchProp<DanaStandardReturnOrderActions>>;

export const SetLoadingTrue: HandlerType = props => {
    props.dispatch?.({
        type: "StandardReturn/IsLoading",
        isLoading: true,
    });
}

export const SetStandardReturnOrderSubmitParameters: HandlerType = props => {
    const apiParameters = { ...props.parameter } as SubmitStandardReturnOrderApiParameter;
    props.apiParameter = apiParameters;
}


export const SubmitStandardReturnOrder: HandlerType = async props => {
    props.apiResult = await submitStandardReturnOrderResult({ ...props.apiParameter });
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch?.({
            type: "StandardReturn/PopulateSubmitOrderResult",
            orderNumber: props.apiResult.result.orderNumber,
            salseOrgDetails: props.apiResult.result.salseOrgDetails
        } as any);
    }
}
export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);

};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult?.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};
export const SetLoadingFalse: HandlerType = props => {
    props.dispatch?.({
        type: "StandardReturn/IsLoading",
        isLoading: false,
    });
}
export const chain = [SetLoadingTrue, SetStandardReturnOrderSubmitParameters, SubmitStandardReturnOrder, PopulateFacetResult, ExecuteOnSuccessCallback,ExecuteOnErrorCallback, SetLoadingFalse];

const submitStandardReturnOrder = createHandlerChainRunner(chain, "SubmitStandardReturnOrder");
export default submitStandardReturnOrder;